<template lang="pug">
  div
    v-card(class="mb-12" height="auto")
      v-layout(row wrap)
        v-flex(xs12 sm12) 
            h3(class="headerSection") Latar Belakang Perubahan
            br
        v-flex( sm12)
            div(style="margin: 0 15px 35px 15px;padding: 0;}")
                ckeditor(:editor="editor" v-model="dataSubmitPerubahan.ipLatarBelakang" :config="editorConfig")
        
        v-flex(xs5 sm2) 
            h3(class="headerSection") Lampiran
        v-flex(
          xs6 
          sm4 
          class="attachment" 
          v-if="!dataSubmitPerubahan.ipLatarBelakangUploadId && ( !docPerubahan || docPerubahan.size > 10000000 )"
        )
            v-file-input(
              id="firt-document" 
              :rules="rules"  
              label="Hanya 1 file, max 10MB" 
              v-model="docPerubahan"
            )
                template(v-slot:selection="{ text }" )
                    v-chip(
                      small 
                      label 
                      color="primary"
                    ) {{ text }}
        v-flex(
          xs6 
          sm4 
          class="attachmentName" 
          v-else
        )
            span(id="firt-document") {{ getNameFile('docPerubahan') }}
            v-btn(icon color="red" @click="deleteDocPerubahan('docPendukung')")
                v-icon mdi-close
        v-flex(xs1 sm5)

        v-flex(xs12 sm12 style="margin-top:12px") 
            h3(class="headerSection") Perubahan yang Diusulkan
            br
        v-flex( sm12)
            div(style="margin: 0 15px 35px 15px;padding: 0;}")
                ckeditor(:editor="editor" v-model="dataSubmitPerubahan.ipPerubahanDiusulkan" :config="editorConfig")
        
        v-flex(xs5 sm2) 
            h3(class="headerSection") Lampiran
        v-flex(
          xs6 
          sm4 
          class="attachment" 
          v-if="!dataSubmitPerubahan.ipPerubahanDiusulkanUploadId && ( !docUsulan || docUsulan.size > 10000000 )"
        )
            v-file-input(
              id="firt-document" 
              :rules="rules"  
              label="Hanya 1 file, max 10MB" 
              v-model="docUsulan"
              )
                template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary") {{ text }}
        v-flex(
          xs6 
          sm4 
          class="attachmentName" 
          v-else
        )
            span(id="firt-document") {{ getNameFile('docUsulan') }}
            v-btn(icon color="red" @click="deleteDocUsulan('docPendukung')")
                v-icon mdi-close
        v-flex(xs1 sm5)


    v-btn(class="mr-3" dark color='blue-grey' @click="backStep(2);scrollTop();") BACK
    v-btn(text class="mr-3"  @click="backHome()") Cancel
    v-btn(color="primary" @click="nextStep(4); scrollTop();" :disabled="!isPageComplete") Continue
      
</template>

<script>
import { mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../../utils/MyUploadAdapter";
import PemegangModal from "../PemegangModal.vue";
import axios from "axios";
export default {
  name: "LatarBelakang",
  components: {
    PemegangModal
  },
  props: ["e1","dataSubmitPerubahan"],
  data() {
    return {
    editor: ClassicEditor,
    editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ["ImageUpload", "MediaEmbed"],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
            ],
            styles: [
            // This option is equal to a situation where no style is applied.
            "full",
            // This represents an image aligned to the left.
            "alignLeft",
            // This represents an image aligned to the right.
            "alignRight",
            ],
        },
    },
      docPerubahan: null,
      docUsulan : null,
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
    klasifikasiOptions: [
        'Jenis Peralatan',
        'Lokasi Aktivasi',
        'Nomor Peralatan',
        'Organisasi',
        'Prosedur',
        'Perangkat Lunak',
        'Proses',
        'Rencana Tambang',
        'Bahan Berbahaya',
        'Tata Letak',
        'Desain & Konstruksi',
        'Perubahan Jalan'
    ],
    };
  },
  mounted() {},
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers"]),
    isPageComplete: function () {
      return (
        !!this.dataSubmitPerubahan.ipLatarBelakang &&
        !!this.dataSubmitPerubahan.ipPerubahanDiusulkan 
      );
    },
  },
  methods: {
    nextStep(val){
     this.$emit("continueBtn", val);
    },
    backStep(val){
     this.$emit("continueBtn", val);
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    scrollTop(){
      window.scrollTo(0,0);
    },
    docName(name){
        return this.$setFilename(name);
      },
    deleteDocPerubahan(name){
        const id = this.dataSubmitPerubahan.ipLatarBelakangUploadId;   
        this.$store
          .dispatch("deleteFile", {
              uploadId: id,
              folderName: name,
          })
          .then(() => {
            this.docPerubahan = null;
            this.dataSubmitPerubahan.ipLatarBelakangUploadId = ""
            this.dataSubmitPerubahan.ipLatarBelakangLampiran = {}
          })
          .catch(() => {
              this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
    },
    deleteDocUsulan(name){
      const id = this.dataSubmitPerubahan.ipPerubahanDiusulkanUploadId;   
      this.$store
        .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
        })
        .then(() => {
          this.docUsulan = null;
          this.dataSubmitPerubahan.ipPerubahanDiusulkanUploadId = ""
          this.dataSubmitPerubahan.ipPerubahanDiusulkanLampiran = {}
        })
        .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    getNameFile(params) {
      if ( params == 'docPerubahan' ) {
        return this.docName(this.dataSubmitPerubahan.ipLatarBelakangLampiran.docPendukung)
      } else if ( params == 'docUsulan' ) {
        return this.docName(this.dataSubmitPerubahan.ipPerubahanDiusulkanLampiran.docPendukung)
      }

    }
  },
  watch: {
    docPerubahan(params){
      if(params && params.size < 10000000){
        let formData = new FormData();
        formData.append('uploadId', Date.now() );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res =>{
          this.dataSubmitPerubahan.ipLatarBelakangUploadId = res.data.uploadId
          this.dataSubmitPerubahan.ipLatarBelakangLampiran.docPendukung = res.data.file.filename
        })
      }
    },
    docUsulan(params){
      if(params && params.size < 10000000){
        let formData = new FormData();
        formData.append('uploadId', Date.now() );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res =>{
          this.dataSubmitPerubahan.ipPerubahanDiusulkanUploadId = res.data.uploadId
          this.dataSubmitPerubahan.ipPerubahanDiusulkanLampiran.docPendukung = res.data.file.filename
        })
      }
    }
  },
};
</script>

<style></style>
